export default {"src":"/_next/static/media/lsk.bd8b98de.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};